// eslint-disable-next-line no-shadow
export enum CommonScreens {
  'Webview' = 'Webview',
  'ConversationList' = 'ConversationList',
  'Chat' = 'Chat',
  'ImagePreview' = 'ImagePreview',
  'PrinterSetting' = 'PrinterSetting',
  'AssignShopper' = 'AssignShopper',
}
